<template>
  <div>
    <div id="PCGroupAndFriendView">
      <b-card no-body class="fullHeight">
        <b-tabs card v-model="tabIndex" justified>
          <b-tab title="好友群組" active>
            <transition name="fade">
              <FriendGroup
                :mode="mode"
                v-on:setChoiseGroup="setChoiseGroup"
              ></FriendGroup>
            </transition>
          </b-tab>
          <b-tab :title="group.GroupName">
            <FriendList :mode="mode" :group="group"></FriendList>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>
import FriendGroup from "../components/Main/FriendGroup.vue";
import FriendList from "../components/Main/FriendList.vue";
import store from "../vuex/store_friendList.js";
import { TutorChatTokenHandler } from "@/handler/TutorChatTokenHandler.js";
import { SignalrConnectionHandler } from "@/handler/SignalrConnectionHandler.js";
export default {
  components: {
    FriendGroup,
    FriendList,
  },
  data() {
    return {
      tabIndex: 0,
      group: [],
      mode: {
        type: "PC",
        token: "",
        staff: [],
      },
    };
  },
  created() {
    this.mode.staff = this.GetLoginStaff();
    var ticket = this.GetTicket();

    this.mode.token = TutorChatTokenHandler.getTctToken(ticket);
    this.iniSignalr();
  },
  // 元件銷毀時一定要停掉連線。SignalrConnectionHandler 會無限退避重連，
  // 沒停的話 SPA route 切換後會留下永遠重連的殭屍連線，而且每次重連都會再
  // 跑一次 onConnected（AddGroup / GetDataByToken），觸發 server 端的單一
  // 登入檢查去 closepage 掉當前活著的那條連線。
  beforeDestroy() {
    if (this.signalrconn && typeof this.signalrconn.stop === "function") {
      this.signalrconn.stop();
    }
  },
  methods: {
    iniSignalr: function () {
      //群組列表的signalr
      //這裡一定要把mode裡面的staffid裝起來用，滿怪的，可能是型態問題。
      var staffid = this.mode.staff.staffid;
      this.signalrconn = SignalrConnectionHandler.Create({
        url: this.$conf.MessageAPI + "/signalr",
        hub: "mainfriendListHub",
        // 重連後 server 端 group 成員資格不會保留，必須重新 AddGroup
        onConnected: function (proxy) {
          proxy.invoke("AddGroup", staffid);
        },
      });
      var proxy = this.signalrconn.proxy;
      this.signalrconn.start();

      //更新全部好友未讀數
      proxy.on("refreshGroupUnreadCount", (notify) => {
        store.dispatch("refreshGroupUnreadCount", notify);
      });
      //好友列表的signalr
      //更新好友清單未讀數
      proxy.on("refreshFriendUnreadCount", (data) => {
        store.dispatch("RefreshUnreadCount", data);
      });

      //關閉頁面
      proxy.on("closepage", (data) => {
        this.signalrconn.stop();
        window.open("", "_self", "");
        window.close();
      });
    },
    setChoiseGroup: function (group) {
      this.group = group;
      this.tabIndex = 1;
    },
  },
};
</script>
<style>
#PCGroupAndFriendView {
  height: 100%;
  overflow: auto;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 13px;
  padding: 15px;
  position: absolute;
  padding: 0px;
  left: 90px;
  width: 399px !important;
}

#PCGroupAndFriendView .card-header {
  height: 64px;
  background: none;
  border: none;
  padding: 0.75rem 0.6rem 2em;
  background: #e8e8e8;
}

#PCGroupAndFriendView .card {
  border: none;
}

#PCGroupAndFriendView .card-body {
  padding: 0;
}

#PCGroupAndFriendView .card-header .nav-tabs .nav-link {
  border-radius: 50px;
  color: #444;
  font-size: 15px;
  padding: 0.6rem 1rem;
}

#PCGroupAndFriendView .card-header .nav-tabs .nav-link.active {
  background: #b20404;
  color: #fff;
}

#PCGroupAndFriendView .nav-tabs .nav-link {
  border: none;
}
#PCGroupAndFriendView .nav-tabs .nav-item {
  margin-bottom: 0;
  text-align: center;
}

#PCGroupAndFriendView .list-group-flush .list-group-item {
  background: #f1f1f1;
  color: #929292;
  border: none;
  border-radius: 5px;
  margin: 7px 0;
}

@media (max-width: 340px) {
  #PCGroupAndFriendView .card-header .nav-tabs .nav-link {
    font-size: 14px;
    padding: 0.6rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/PCGroupAndFriendView.vue